import { ReactComponent as Edit } from './edit.svg';

export default Edit;
